import { render } from "./ModalService.vue?vue&type=template&id=6a101e3c"
import script from "./ModalService.vue?vue&type=script&lang=js"
export * from "./ModalService.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__